module.exports = __webpack_public_path__ + "static/media/wizualizacja-112.8e3c5f84.png";